import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import userAndOrganizationActivityAnalyticService from '../../../services/user-and-organization-activity-analytics.service';

const ActiveUsersChart = () => {
  const [activeUserAnalytics, setActiveUserAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getActiveUserAnalytics = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await userAndOrganizationActivityAnalyticService.getActiveUsersAnalytics();
        setActiveUserAnalytics(data);
      } catch (err) {
        console.error('Error fetching active users metrics:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getActiveUserAnalytics();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load active users metrics details.
      </div>
    );
  }

  const categories = ['Past 24 hours', 'Past 7 days', 'Past 30 days'];
  const dataPoints = [
    activeUserAnalytics?.active_user_counts['24h'] ?? 0,
    activeUserAnalytics?.active_user_counts['7d'] ?? 0,
    activeUserAnalytics?.active_user_counts['30d'] ?? 0,
  ];

  const chartOptions = {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    markers: {
      size: 6,
      colors: ['#16A34A'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: { sizeOffset: 3 },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '13px',
        fontWeight: 'bold',
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 4,
        padding: 4,
        opacity: 0.9,
        dropShadow: {
          enabled: true,
          top: 1,
          left: 1,
          blur: 2,
          color: '#000',
          opacity: 0.3,
        },
      },
    },
    xaxis: {
      categories,
      labels: { style: { fontSize: '13px' } },
    },
    yaxis: {
      title: { text: 'Active Users' },
      labels: {
        formatter: (val) => Math.round(val),
        style: { fontSize: '13px' },
      },
      forceNiceScale: true,
      tickAmount: dataPoints.length,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} users`,
      },
    },
    colors: ['#16A34A'],
    grid: {
      borderColor: '#e0e0e0',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Active Users',
      data: dataPoints,
    },
  ];

  return (
    <div className="mt-3">
      <Chart options={chartOptions} series={series} type="line" height={300} />
    </div>
  );
};

export default ActiveUsersChart;
